import React from "react";
import axios from "axios";
import ResultCard from "../../components/Cards/ResultCard/ResultCard";

//React Router
import { useParams } from "react-router-dom";

import "./productSearchResult.scss";
import { Link } from "react-router-dom";

const ProductSearchResult = () => {
  const { city, startDate, endDate } = useParams();
  const [products, setProducts] = React.useState(null);

  let path = "";
  let searchResultTitle = "";

  if (city && startDate && endDate) {
    path = `city/${city}/dates/${startDate}/${endDate}`;
    if (products) {
      searchResultTitle = `Vehículos disponibles en ${products[0].location.city}, 
    ${products[0].location.country} desde ${startDate} hasta ${endDate}`;
    }
  } else if (city) {
    path = `city/${city}`;
    if (products) {
      searchResultTitle = `Vehículos disponibles en ${products[0].location.city}, 
    ${products[0].location.country}`;
    }
  } else if (startDate && endDate) {
    path = `dates/${startDate}/${endDate}`;
    if (products) {
      searchResultTitle = `Vehículos disponibles desde ${startDate} hasta ${endDate}`;
    }
  }

  //API PRODUCTOS
  React.useEffect(() => {
    const fetchProductResult = async () => {
      try {
        const resultado = await axios(
          `${process.env.REACT_APP_ROOT_BACKEND_ENDPOINT}/products/${path}`
        );
        setProducts(resultado.data);
      } catch (error) {
        console.log(error.message);
      }
    };
    fetchProductResult();
  }, [path]);

  return products ? (
    <div className="resultPage__container">
      {products.length === 0 ? (
        <p className="emptyResults">
          Esta ubicación no tiene productos disponibles.{" "}
          <Link to="/home" style={{ color: "#f0572d" }}>
            Vuelve a buscar
          </Link>
        </p>
      ) : (
        <section className="product_cards">
          <h2>{searchResultTitle}</h2>
          <div className="product_cards_container">
            {products.map((product) => (
              <ResultCard data={product} key={product.title} />
            ))}
          </div>
        </section>
      )}
    </div>
  ) : (
    <div className="resultPage__container">
      <h2 className="product__loading">Loading data...</h2>
    </div>
  );
};

export default ProductSearchResult;
